export default __webpack_public_path__ + "static/media/crown.fe073265.svg";